import { render, staticRenderFns } from "./GenericTextArea.vue?vue&type=template&id=3dfa5b41&"
import script from "./GenericTextArea.vue?vue&type=script&lang=js&"
export * from "./GenericTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports